var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 15C15.3137 15 18 12.3137 18 9 18 5.68629 15.3137 3 12 3 8.68629 3 6 5.68629 6 9 6 12.3137 8.68629 15 12 15zM2.90625 20.2491C3.82834 18.6531 5.1542 17.3278 6.75064 16.4064 8.34708 15.485 10.1579 15 12.0011 15 13.8444 15 15.6552 15.4851 17.2516 16.4065 18.848 17.3279 20.1739 18.6533 21.0959 20.2493", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});